import { types } from 'mobx-state-tree';

import Actions from './Actions';
import Views from './Views';

// just keep it simple, since we have already a contact model
// and here is the same model but with a small changes
const Contact = types.custom({
  name: 'Contact',
  fromSnapshot() {
    return {};
  },
  toSnapshot() {
    return {};
  },
  isTargetType() {
    return true;
  },
});

const SaveToCrmOptionsType = {
  title: types.maybeNull(types.string),
  className: types.maybeNull(types.string),
  contact: types.maybeNull(Contact),
  platformSelectionType: types.maybeNull(types.string),
  isBulkSave: types.maybeNull(types.boolean),
  selectedIntegration: types.maybeNull(types.string),
};
const ModelProps = {
  isSaveToCrmPopupIsOpen: types.optional(types.boolean, false),
  saveToCrmPopupOptions: types.maybeNull(types.model(SaveToCrmOptionsType)),
};

const SaveToCrm = types
  .model(ModelProps)
  .actions(Actions)
  .views(Views);

export default SaveToCrm;
